import { render, staticRenderFns } from "./TNavItem.vue?vue&type=template&id=40bbd992&scoped=true&"
import script from "./TNavItem.vue?vue&type=script&lang=js&"
export * from "./TNavItem.vue?vue&type=script&lang=js&"
import style0 from "./TNavItem.vue?vue&type=style&index=0&id=40bbd992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbd992",
  null
  
)

export default component.exports